import React, { Component } from "react";

import { series } from "../../utils/misc";

class SelectSeries extends Component {
  constructor(props) {
    super(props);
    this.state = {
      options: series,
      value: '',
      error: ''
    };
    this.onChange = props.onChange;
  }

  static getDerivedStateFromProps(nextProps, prevState) {
    if (nextProps.serie !== prevState.value
      || nextProps.error !== prevState.error) {
      return {
        value: nextProps.serie,
        error: nextProps.error
      };
    }
    return null;
  }

  handleChange = (event) => {
    event.preventDefault();
    const value = event.target.value;
    if (this.state.value !== value) {
      this.setState({ value: value }, this.onChange(this.props.name, value));
    }
  };

  render() {
    const { options, value, error } = this.state;

    return (
      <select
        value={value}
        onChange={this.handleChange}
        onBlur={this.handleChange}
        className={'custom-select' + (error ? ' is-invalid' : '')}
        required={this.props.required}
      >
        <option value=""></option>
        {options.map((v, i) => <option key={i} value={v.value}>{v.label}</option>)}
      </select>
    )
  }
}

export default SelectSeries;
